/**
 * CheckboxHelpers — 사용자PC(/u/orders) 오더 테이블/필터 팝업의 체크박스 공용 헬퍼.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 리프 헬퍼 7함수를 이관했다(세금/다중발행 코어 슬라이스 A):
 *   check_all_not / unSelDoPreList / make_checkBoxStatus / tr_checkbox_onoff /
 *   checkdoneornot / get_checked_order_list / toggle_checkbox_all
 * 아웃고잉 결합이 없는 순수 DOM 헬퍼라 가장 먼저 분리한다.
 *
 * 구조: 모듈 스코프 자유함수 + 브리지 클래스 (ListRender/DateToolbar 와 동일).
 *   - 공유 상태 lastPageCheckSt 는 window.lastPageCheckSt(선언 var 는 u-order-list.js 잔류 —
 *     show_Pop_BizForm 등 잔류 코드도 접근하므로 동일 슬롯 공유).
 *   - strict: 레거시 `for(key in ...)` 의 암묵적 전역 key 를 `for(var key ...)` 로 수정.
 *
 * 진입점은 initialize() 가 7함수를 모두 window 로 브리지한다
 * (블레이드 onclick · 잔류 list.js(show_Pop_BizForm/multi_sel_list_do 등) · SearchFilter 가 호출).
 */

// 필터 팝업 내 전체선택/해제
function check_all_not(tar) {
    var obj = document.getElementById("show_serchFilter");
    var inputs = obj.getElementsByTagName("INPUT");
    var ch = tar.checked;
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == "checkbox") inputs[i].checked = ch;
    }
}

// 페이지 전환 전 체크상태 복원
function unSelDoPreList() {
    for (var key in window.lastPageCheckSt) {
        var ea = window.lastPageCheckSt[key];
        var eaid = ea[0];
        var eaval = ea[1];
        var eastt = ea[2];
        var obj = document.getElementById(eaid);
        if (obj) {
            if (obj.id == eaid && obj.value == eaval) {
                obj.checked = eastt;
            }
        }
    }
}

// 현재 체크상태를 lastPageCheckSt 에 저장
function make_checkBoxStatus() {
    window.lastPageCheckSt = {};
    var obj = document.getElementById("tableListUp");
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == "checkbox") {
            var dtype = inputs[i].getAttribute("dtype");
            if (dtype == "orderchbox") {
                var kk = inputs[i].id + "_" + inputs[i].value;
                window.lastPageCheckSt[kk] = [inputs[i].id, inputs[i].value, inputs[i].checked];
            }
        }
    }
}

// 대상 컨테이너 내 모든 체크박스 on/off
function tr_checkbox_onoff(obj, val) {
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == "checkbox") {
            inputs[i].checked = val;
        }
    }
}

function checkdoneornot(myobj) {
    return;
    var obj1 = document.getElementById("doneonly");
    var obj2 = document.getElementById("notshowdone");
    var ch = myobj.id;
    if (ch == "doneonly") {
        obj2.checked = false;
    }
    if (ch == "notshowdone") obj1.checked = false;
}

// 체크된 오더번호를 콤마결합 문자열로 (안보이는 행 제외)
function get_checked_order_list() {
    let arr = [];
    $('[id^=ordersel_]').each(function (index, item) {
        if ($(item).parent().parent().css('display') == 'none') return; // 안보이면 스킵
        if ($(item).prop('checked')) arr.push($(item).attr('id').replace('ordersel_', ''));
    });
    return arr.join(',');
}

// 오더목록 맨앞 체크박스 일괄 토글
function toggle_checkbox_all() {
    var stt = document.getElementById("orderselall").checked;
    var obj = document.getElementById("tableListUp");
    var inputs = obj.getElementsByTagName("INPUT");
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute("dtype") == "orderchbox") {
            inputs[i].checked = stt;
        }
    }
}

export default class CheckboxHelpers {
    check_all_not = check_all_not;
    unSelDoPreList = unSelDoPreList;
    make_checkBoxStatus = make_checkBoxStatus;
    tr_checkbox_onoff = tr_checkbox_onoff;
    checkdoneornot = checkdoneornot;
    get_checked_order_list = get_checked_order_list;
    toggle_checkbox_all = toggle_checkbox_all;
}
